import React from "react";

type TextContent = {
  text: string;
  textStyle: string;
};

export const Header1: React.FC<TextContent> = ({
  text,
  textStyle = "text-green_s4",
}) => {
  return (
    <h1 className={`text-3xl desktop:text-6xl font-medium ${textStyle}`}>{text}</h1>
  );
};

export const Header2: React.FC<TextContent> = ({
    text,
    textStyle = "text-green_s4",
  }) => {
    return (
      <h1 className={`text-3xl desktop:text-5xl font-semibold ${textStyle}`}>{text}</h1>
    );
  };

  export const Header3: React.FC<TextContent> = ({
    text,
    textStyle = "text-black",
  }) => {
    return (
      <h1 className={`text-3xl tablet:text-3xl desktop:text-4xl font-medium ${textStyle}`}>{text}</h1>
    );
  };

export const Paragraph: React.FC<TextContent> = ({
  text,
  textStyle = "text-black",
}) => {
  return (
    <p className={`text-sm desktop:text-xl tablet:text-base font-base ${textStyle}`}>{text}</p>
  );
};
